module.exports = __webpack_public_path__ + "static/media/14x11.22fcfbba.png";